import styles from "../CategorizedNomenclatureListPage.module.scss";
import { classNames } from "primereact/utils";

const DEFAULT_CATEGORIES_COUNT = 4;
const DEFAULT_ITEMS_COUNT = 5;

interface ICategorizedNomenclatureSkeletonProps {
  categoriesCount?: number;
  itemsCount?: number;
}

export const CategorizedNomenclatureSkeleton = ({
  categoriesCount = DEFAULT_CATEGORIES_COUNT,
  itemsCount = DEFAULT_ITEMS_COUNT,
}: ICategorizedNomenclatureSkeletonProps) => {
  return (
    <div className={styles.skeleton_container}>
      {Array.from({ length: categoriesCount }).map((_, categoryIndex) => (
        <div
          key={`skeleton-category-${categoryIndex}`}
          className={classNames(styles.skeleton_category, {
            [styles.skeleton_category_expanded]: categoryIndex === 0,
          })}
        >
          <div className={styles.skeleton_category_header}>
            <span className={styles.skeleton_category_name} />
            <span className={styles.skeleton_category_count} />
          </div>
          {categoryIndex === 0 && (
            <div className={styles.skeleton_category_content}>
              {Array.from({ length: itemsCount }).map((_, itemIndex) => (
                <div
                  key={`skeleton-item-${itemIndex}`}
                  className={styles.skeleton_item}
                >
                  <span className={styles.skeleton_item_name} />
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
